import AssessmentFeedbackModal from './index';
const meta = {
    title: 'Features/IIMReview/AssessmentFeedbackModal',
    component: AssessmentFeedbackModal,
    parameters: { layout: 'centered' },
    args: {
        isOpen: true,
        onClose: () => undefined,
        onSubmit: (reasonCode, details) => {
            // eslint-disable-next-line no-console
            console.log('submitted', { reasonCode, details });
        }
    }
};
export default meta;
export const Open = {};
export const Closed = {
    args: { isOpen: false }
};
